import type React from 'react';
import Sidenav from './SideNav';
import StartNow from '../../organisms/StartNow';

interface Props {
  children: React.ReactNode;
}

const SchoolWrapper = ({ children }: Props) => {
  return (
    <div>
      <div className="school-wrapper">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-3">
              <Sidenav />
            </div>
            <div className="col-span-12 md:col-span-9">{children as any}</div>
          </div>
        </div>
      </div>
      <StartNow />
    </div>
  );
};

export default SchoolWrapper;
